var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('FormInput',{staticClass:"w-1/2",attrs:{"value":_vm.value,"type":"select","options":_vm.industryList},on:{"input":s => _vm.$emit('input', s)}}),_vm._v(" "),_c('ErrorText',{attrs:{"name":"industry","errors":_vm.errors}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }